(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    function measure(host) {
      const list = host.querySelector('overflow-list');
      if (!list) return;
      const items = Array.from(list.children).filter(
        (el) => !el.hasAttribute('slot') && el.getClientRects().length > 0
      );
      if (items.length < 2) return;
      const a = items[0].getBoundingClientRect();
      const b = items[1].getBoundingClientRect();
      const pitch = Math.round(Math.abs(b.left - a.left) * 10) / 10;
      if (pitch > 0 && host.dataset.measuredPitch !== String(pitch)) {
        host.dataset.measuredPitch = String(pitch);
        host.style.setProperty('--swatch-pitch-mobile', pitch + 'px');
      }
    }

    function run() {
      if (!mobile.matches) return;
      document.querySelectorAll('product-swatches[data-swatch-mobile-max]').forEach(measure);
    }

    let queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        run();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    mobile.addEventListener('change', schedule);

    /* Re-measure when cards are added (filters, infinite scroll, theme editor). */
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
